import UIModal from 'UIComponents/dialog/UIModal';
import UILogo from 'UIComponents/image/UILogo';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Flex } from 'foundations-components/components/Flex';
import UIBox from 'UIComponents/layout/UIBox';
import UIImage from 'UIComponents/image/UIImage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import Blob from '../utils/Blob';
import { useDispatch } from 'react-redux';
import { skipPasskeySetupNudge } from '../actions/PasskeysActions';
// @ts-expect-error ts-migrate(7016)
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
// @ts-expect-error ts-migrate(2307)
import securityFaceLogo from 'bender-url!../../images/security-face.svg';
// @ts-expect-error ts-migrate(2307)
import biometric from 'bender-url!../../images/biometric.svg';
// @ts-expect-error ts-migrate(2307)
import phoneNumber from 'bender-url!../../images/phone-number.svg';
import styled from 'styled-components';
import { trackPasskeyLearnMore, trackPasskeyNudgeSetupInitiated } from '../lib/tracker';
import { PASSKEYS_KB_URL } from '../constants/Passkeys';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PasskeySetupOrSkipModal__StyledDiv",
  componentId: "sc-1929xcr-0"
})(["width:128px;position:absolute;left:40px;top:30px;"]);
const PasskeySetupOrSkip = ({
  createPasskey,
  email,
  passkeyRedirectUrl,
  isVariant
}) => {
  const dispatch = useDispatch();
  const handleSetup = () => {
    trackPasskeyNudgeSetupInitiated();
    /* eslint-disable-next-line promise/catch-or-return, @typescript-eslint/no-floating-promises */
    createPasskey(email, true, passkeyRedirectUrl);
  };
  const handleSkip = () => {
    dispatch(skipPasskeySetupNudge(passkeyRedirectUrl));
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 900,
    "data-test-id": "passkey-nudge-modal",
    children: [/*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsx(UILogo, {
        name: "hubspot-wordmark"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      marginBlockStart: "1400",
      padding: "1400",
      children: [/*#__PURE__*/_jsx(UIBox, {
        basis: 400,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h1", {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: !isVariant ? 'userPreferences.passkeys.nudgeVariantB.title' : 'userPreferences.passkeys.nudgeVariant.title'
              })
            }), /*#__PURE__*/_jsx(Text, {
              marginInlineEnd: "1400",
              paddingInlineEnd: "1400",
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: !isVariant ? 'userPreferences.passkeys.nudgeVariantB.description' : 'userPreferences.passkeys.nudgeVariant.description'
              })
            })]
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: handleSetup,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "userPreferences.passkeys.nudgeVariantB.setupButton"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: handleSkip,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "userPreferences.passkeys.nudgeVariantB.skipButton"
            })
          }), /*#__PURE__*/_jsxs(View, {
            marginBlockStart: "400",
            marginInlineStart: "0",
            children: [/*#__PURE__*/_jsx(KnowledgeBaseButton, {
              url: PASSKEYS_KB_URL,
              onClick: () => trackPasskeyLearnMore()
            }), ' ']
          })]
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(Blob, {
          children: /*#__PURE__*/_jsxs(View, {
            marginInlineStart: "100",
            children: [/*#__PURE__*/_jsx(View, {
              blockSize: "80",
              marginBlockEnd: "600",
              children: /*#__PURE__*/_jsx(UIImage, {
                src: biometric
              })
            }), /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(View, {
                blockSize: "80",
                marginInlineEnd: "800",
                children: /*#__PURE__*/_jsx(UIImage, {
                  src: securityFaceLogo
                })
              }), /*#__PURE__*/_jsx(View, {
                blockSize: "80",
                children: /*#__PURE__*/_jsx(UIImage, {
                  src: phoneNumber
                })
              })]
            })]
          })
        })
      })]
    })]
  });
};
export default PasskeySetupOrSkip;